"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosRequestBuilderWithPipeline = void 0;
const guard_1 = require("../utils/guard");
/**
 * An Axios request builder with a pipeline.
 */
class AxiosRequestBuilderWithPipeline {
    /**
     * Initializes a new instance of the @see AxiosRequestBuilder class.
     */
    constructor() {
        this.headers = {};
        this.url = '';
        this.method = 'GET';
        this.body = null;
        this.maxContentLength = 10 * 1024 * 1024; // 10MB
        this.cancelToken = null;
        this.responseType = null;
        this.requestId = null;
        this.params = {};
    }
    /**
     * Gets a new builder.
     * @returns The builder.
     */
    static new() {
        return new AxiosRequestBuilderWithPipeline();
    }
    /**
     * Uses a pipeline.
     * @param pipeline Pipeline to use.
     * @returns The builder.
     */
    usePipeline(pipeline) {
        guard_1.Guard.throwIfNullOrEmpty(pipeline, 'pipeline');
        this.pipeline = pipeline;
        return this;
    }
    /**
     * Sends the request.
     * @param cacheKey Optional key for the cache.
     * @returns Web response.
     */
    execute(cacheKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.build();
            const result = yield this.pipeline.execute(request, cacheKey, this.requestId);
            return result;
        });
    }
    /**
     * Uses a custom request Guid for request logging.
     * @param requestId Guid to use.
     */
    withRequestGuid(requestId) {
        this.requestId = requestId;
        return this;
    }
    /**
     * Adds a custom header.
     * @param name Header name.
     * @param value Header value.
     * @returns The builder.
     */
    addHeader(name, value) {
        this.headers[name] = value;
        return this;
    }
    /**
     * Adds a request body.
     * @param body Request body to add.
     * @returns The builder.
     */
    withBody(body) {
        this.body = body;
        return this;
    }
    /**
     * Sets the URL.
     * @param url URL to use.
     * @returns The builder.
     */
    withUrl(url) {
        this.url = url;
        return this;
    }
    /**
     * Sets the maximum content length for the request.
     * @param value Maximum content length.
     * @returns The builder.
     */
    withMaxContentLength(value) {
        this.maxContentLength = value;
        return this;
    }
    /**
     * Sets a cancel token for the request.
     * @param value Cancel token to use.
     * @returns The builder.
     */
    withCancelToken(value) {
        this.cancelToken = value;
        return this;
    }
    /**
     * Sends a DELETE request.
     * @param url Optional URL to use.
     * @returns The builder.
     */
    delete(url = null) {
        this.method = 'DELETE';
        if (url) {
            this.url = url;
        }
        return this;
    }
    /**
     * Sends a GET request.
     * @param url Optional URL to use.
     * @returns The builder.
     */
    get(url = null) {
        this.method = 'GET';
        if (url) {
            this.url = url;
        }
        return this;
    }
    /**
     * Sends a HEAD request.
     * @param url Optional URL to use.
     * @returns The builder.
     */
    head(url = null) {
        this.method = 'HEAD';
        if (url) {
            this.url = url;
        }
        return this;
    }
    /**
     * Sends an OPTIONS request.
     * @param url Optional URL to use.
     * @returns The builder.
     */
    options(url = null) {
        this.method = 'OPTIONS';
        if (url) {
            this.url = url;
        }
        return this;
    }
    /**
     * Sends a PATCH request.
     * @param url Optional URL to use.
     * @returns The builder.
     */
    patch(url = null) {
        this.method = 'PATCH';
        if (url) {
            this.url = url;
        }
        return this;
    }
    /**
     * Sends a POST request.
     * @param url Optional URL to use.
     * @returns The builder.
     */
    post(url = null) {
        this.method = 'POST';
        if (url) {
            this.url = url;
        }
        this.headers['Content-Type'] = 'application/json';
        return this;
    }
    /**
     * Sends a PUT request.
     * @param url Optional URL to use.
     * @returns The builder.
     */
    put(url = null) {
        this.method = 'PUT';
        if (url) {
            this.url = url;
        }
        return this;
    }
    /**
     * Sets a response type.
     * @param value Value to set.
     * @returns The builder.
     */
    withResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
     * Adds a query parameter to the request.
     * @param name Name of the query paramter.
     * @param value Value of the query parameter.
     * @returns The builder.
     */
    addQueryParameter(name, value) {
        guard_1.Guard.throwIfNullOrEmpty(name, 'name');
        guard_1.Guard.throwIfNullOrEmpty(value, 'value');
        this.params[name] = value;
        return this;
    }
    /**
     * Builds the request.
     * @returns Axios request configuration.
     */
    build() {
        const result = {};
        result.cancelToken = this.cancelToken;
        result.data = this.body;
        result.headers = this.headers;
        result.maxContentLength = this.maxContentLength;
        result.method = this.method;
        result.url = this.url;
        result.responseType = this.responseType;
        if (Object.keys(this.params).length > 0) {
            result.params = this.params;
        }
        return result;
    }
}
exports.AxiosRequestBuilderWithPipeline = AxiosRequestBuilderWithPipeline;
//# sourceMappingURL=axiosRequestBuilderWithPipeline.js.map